import React, { ChangeEvent, useEffect, useState } from 'react';
import OverlayIcon from 'Components/GMS/Rules/Components/OverlayIcon';
import { tooltips } from '../utils/ABHelper';

type InputBoxWinThresholdProps = {
    initialValue?: number;
    onChange: (value: number) => void;
    label: string
}

function InputBoxWinThreshold({ initialValue = 0, onChange, label }: InputBoxWinThresholdProps) {
    const [value, setValue] = useState<string>(initialValue.toString());

    useEffect(() => {
        setValue(initialValue.toString());
    }, [initialValue]);

    const normalizeNumber = (value: string): string => {
        if (value === '') return value
    
        const parts = value.split('.')
        const integerPart = parts[0].replace(/^0+/, '') || '0'
        const decimalPart = parts[1] || ''
    
        const normalized = [
            integerPart,
            decimalPart ? '.' + decimalPart : ''
        ].join('')
    
        return normalized
    }
    
    const validateNumber = (value: string): boolean => {
        // Only allow positive numbers or empty string
        const numberRegex = /^\d*(?:\.\d*)?$/
        if (!numberRegex.test(value)) return false
        if (value === '') return true
        
        // Ensure the number is not negative
        const num = parseFloat(value)
        return !isNaN(num) && num >= 0
    }
    
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value
        if (!validateNumber(newValue)) return
    
        const normalizedValue = normalizeNumber(newValue)
        setValue(normalizedValue)
    
        if (normalizedValue !== '') {
            onChange(parseFloat(normalizedValue))
        }
    }
    
    const handleBlur = () => {
        if (value === '') {
            setValue('0')
            onChange(0)
        }
    }

    return (
        <div>
            <div className='tw-flex tw-items-center tw-gap-2'>
                <label className="text-caption-style">{label}</label>
                <OverlayIcon
                    placement="right"
                    message={
                        <>
                            <p>{tooltips["Minimum Lift Percentage"]}</p>
                            <br />
                            <p>{tooltips["Minimum Lift Percentage Note"]}</p>
                        </>
                    }
                />
            </div>
            <div className='tw-flex tw-items-center tw-gap-3 tw-mt-2'>
            <input
                type="text"
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                className="shadow-none drop-down-dm tw-ps-2 tw-w-32"
            />
                %
            </div>

        </div>
    );
}

export default InputBoxWinThreshold